module.exports = __webpack_public_path__ + "static/ernährung-75337d7180738a4148922756ec382a88.png";